// extracted by mini-css-extract-plugin
export default {"panel":"StoreInfoPanel_panel__sK78u","tabs":"StoreInfoPanel_tabs__qXPVe","emptyState":"StoreInfoPanel_emptyState__E77AG"};